import client from './client';
import { normalizeAuditRow } from '../component/Admin/shared/auditDiff';
import { fetchAllPages } from './fetchAllPages';

function toNullIfBlank(value) {
  if (value === undefined || value === null) return null;
  const text = String(value).trim();
  return text ? text : null;
}

function unwrapPayload(responseData) {
  const envelope = responseData ?? {};
  return envelope.data ?? envelope;
}

function normalizeAuditParams(params = {}) {
  const next = {};

  const perPage = Number(params.per_page ?? params.perPage ?? 25);
  if (Number.isFinite(perPage) && perPage > 0) {
    next.per_page = perPage;
  }

  const page = Number(params.page);
  if (Number.isFinite(page) && page > 0) {
    next.page = page;
  }

  const action = toNullIfBlank(params.action);
  if (action) next.action = action;

  const from = toNullIfBlank(params.from ?? params.from_date ?? params.fromDate);
  if (from) next.from = from;

  const to = toNullIfBlank(params.to ?? params.to_date ?? params.toDate);
  if (to) next.to = to;

  const actorUuid = toNullIfBlank(params.actor_uuid ?? params.actorUuid);
  if (actorUuid) next.actor_uuid = actorUuid;

  const targetUuid = toNullIfBlank(params.target_uuid ?? params.targetUuid);
  if (targetUuid) next.target_uuid = targetUuid;

  return next;
}

function normalizePagination(pagination = null, fallbackCount = 0) {
  if (!pagination) return null;

  return {
    total: Number(pagination.total ?? fallbackCount),
    per_page: Number(pagination.per_page ?? fallbackCount),
    current_page: Number(pagination.current_page ?? 1),
    last_page: Number(pagination.last_page ?? 1),
  };
}

function extractAuditPage(responseData) {
  const payload = unwrapPayload(responseData);
  const items =
    Array.isArray(payload) ? payload :
    Array.isArray(payload.items) ? payload.items :
    Array.isArray(payload.results) ? payload.results :
    [];

  return {
    items: items.map(normalizeAuditRow),
    pagination: normalizePagination(payload?.pagination ?? null, items.length),
  };
}

async function fetchAuditPage(params = {}) {
  const { data } = await client.get('/v1/audit-log', {
    params: normalizeAuditParams(params),
  });

  return extractAuditPage(data);
}

// Not used for the Audit Log tab itself (see AuditLog.jsx — it fetches one
// page at a time to stay fast against a table that only ever grows). Kept
// for any future caller that genuinely needs the full set, now paced
// instead of firing every remaining page at once.
async function listAll(params = {}) {
  return fetchAllPages((page) => fetchAuditPage({ ...params, page }));
}

export const auditLogApi = {
  list: fetchAuditPage,
  listAll,
};

export { extractAuditPage, fetchAuditPage };
